export const GAME_NAME =  'doublewheel';
